import {
  AnalyticalPanel,
  Button,
  Citation,
  DataQualityState,
  MetricLabel,
  ScenarioCard,
  SegmentedControl,
  SourceLabel,
  StatusBadge,
  TextField,
  ValuationWaterfall,
} from '@atlas/ui';

export const designSystemShowcase = {
  colors: {
    canvas: '#070A0F',
    atlasGold: '#D6B86A',
    signalCyan: '#5CC8D7',
  },
  waterfall: [
    { label: 'EV', value: 120, kind: 'start' as const },
    { label: 'Growth', value: 18, kind: 'positive' as const },
    { label: 'Risk', value: -12, kind: 'negative' as const },
    { label: 'Fair', value: 126, kind: 'total' as const },
  ],
};

export function DesignSystemPage() {
  return (
    <div className="space-y-6">
      <header>
        <span className="text-xs uppercase tracking-widest text-[var(--color-atlas-gold)]">
          Obsidian Cartography
        </span>
        <h1 className="text-2xl font-semibold text-[var(--color-text-primary)]">
          Design system
        </h1>
        <p className="text-sm text-[var(--color-text-muted)]">
          Component laboratory — canvas {designSystemShowcase.colors.canvas}
        </p>
      </header>

      <AnalyticalPanel title="Primitives" eyebrow="Controls">
        <div className="flex flex-wrap gap-3">
          <Button variant="primary">Primary</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="danger">Danger</Button>
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          <StatusBadge status="fresh">Fresh</StatusBadge>
          <StatusBadge status="stale">Stale</StatusBadge>
          <StatusBadge status="partial">Partial</StatusBadge>
          <StatusBadge status="contradicted">Contradicted</StatusBadge>
        </div>
        <div className="mt-4 grid max-w-md gap-3">
          <TextField label="Sample field" placeholder="Enter value" hint="Helper text" />
          <SegmentedControl
            ariaLabel="Depth"
            value="guided"
            onChange={() => undefined}
            options={[
              { value: 'concise', label: 'Concise' },
              { value: 'guided', label: 'Guided' },
              { value: 'expert', label: 'Expert' },
            ]}
          />
        </div>
      </AnalyticalPanel>

      <AnalyticalPanel title="Evidence patterns" eyebrow="Data honesty">
        <div className="grid gap-4 md:grid-cols-2">
          <MetricLabel
            label="Implied vol"
            value="18.4"
            unit="%"
            glossaryTermId="glossary.vix"
            status="fresh"
            trend="+1.2 vs 30d"
          />
          <DataQualityState state="stale" />
        </div>
        <div className="mt-4 flex flex-wrap items-center gap-3">
          <SourceLabel source="CBOE" tier="primary" knownAt="2026-07-25" />
          <Citation index={1} title="VIX methodology" meta="CBOE whitepaper" />
        </div>
      </AnalyticalPanel>

      <AnalyticalPanel title="Valuation" eyebrow="Structure">
        <ValuationWaterfall items={designSystemShowcase.waterfall} />
        <div className="mt-4 grid gap-3 md:grid-cols-2">
          <ScenarioCard
            title="Base case"
            probability={55}
            priorProbability={50}
            signal="base"
            description="Continued range-bound regime"
            selected
          />
          <ScenarioCard
            title="Upside"
            probability={25}
            signal="upside"
            description="Policy pivot + liquidity impulse"
          />
        </div>
      </AnalyticalPanel>
    </div>
  );
}
